<template>
  <div>
    <section class="previewer" v-show="isShow" >
      <!-- <img src="/static/images/base/close.png" class="r closed"  @click="isShow=false"> -->
      <div class='title_content' v-if='title'>
          <div class='num_content'>
              {{index}}/{{picList.length}}
          </div>
          <div class='title_conteng'>
              {{arrayTitle?title[index-1]:title}}
          </div>
          <div class='close' @click='isShow = false'>
              x
          </div>
      </div>
      <swiper :options="swiperOption" ref="mySwiper"
              class="mySwiper" >
        <!-- slides -->
        <swiper-slide v-for="(item,index) in picList" class="swiperSlide t_center" :key="index">
          <div class="swiper-zoom-container" >
            <img :src="item | getOriginalPic" class="swiper-lazy" align="middle" >
            <!-- <div class="swiper-lazy-preloader" ></div> -->
            
          </div>
          
        </swiper-slide>
      </swiper>
      <button class="primary pay" style="position: absolute;bottom: 40px;background: rgba(255, 255, 255, 0.4);color:#fff;width:166px;left: calc(50% - 83px);z-index: 999;" @click.stop='submitR()'>我也要拯</button>
      
    </section>
  </div>
</template>

<script>
  import {swiper, swiperSlide} from 'vue-awesome-swiper'
  import 'swiper/dist/css/swiper.css'
  import zhugeObj from "@/assets/js/track";
  export default {
    name: "previewer",
    components:{swiper,swiperSlide},
    props:{
    //   list:{
    //     type:Array,
    //     default:[]
    //   }
    },
    data() {
      const _this = this;
      return {
        isShow:false,
        swiperOption:{
          lazy: {
            loadPrevNext: true,
          },
          preventLinksPropagation : false,
          zoom : true,
          // pagination: {
          //   el: '.swiper-pagination',
          //   type: 'fraction'
          // },
          observer:true,//修改swiper自己或子元素时，自动初始化swiper
          observeParents:true,//修改swiper的父元素时，自动初始化swiper
          on:{
            click: function(){
              _this.isShow = false
            },
            transitionEnd: function(sweiper){
              _this.setIndex()
            },
          },
        },
        index : null,
        picList:[],
        title : '',
        arrayTitle : false
      }
    },
    watch: {
      isShow(value) {
        // console.log(value)
        value ?
          document.body.style.overflow = 'hidden'
          : document.body.style.overflow = '';
      },
    },
    filters:{
      getOriginalPic(pic){
       return pic.split('?')[0]+'?x-oss-process=image/resize,w_800'
      }
    },
    computed: {
      swiper() {
        return this.$refs.mySwiper.swiper
      }
    },
    directives : {

    },
    created() {
    },
    mounted() {
    },
    // updated(){
    //   this.swiper.zoom.attachEvents(true);this.swiper.zoom.attachEvents();
    // },
    methods: {
      submitR(){
        zhugeObj.track({
          title: "案例图片放大页-我也要拯按钮-点击",
        });
        this.$router.push({
          name: "quick"
        });
      },
      setIndex(){
          if(this.swiper){
              this.index = this.swiper.activeIndex + 1;
          }
      },
      show(index,picList,title){
       this.title = title;
       if(title instanceof Array){
         this.arrayTitle = true;
       }
       this.index = index + 1;

       this.picList = picList
     
        // console.log(this.swiper)
        setTimeout(()=>{
          // console.log(this.swiper,index)
          this.swiper.slideTo(index, 0, false)
          this.isShow=true;
          
        },50)
        
      },
      
    }
    
  }
</script>

<style scoped lang="scss">
.title_content{
    position:fixed;
    top:0;
    height: 100px;
    width: 100%;

    display: flex;
    justify-content: space-between;
    &>div{
        line-height: 100px;
        color:#fff;
        font-size: 30px;
    }
    .num_content{
        margin-left: 20px;
    }
    .close{
        margin-right:20px;
        font-size:40px;
    }
}
.previewer{
  width: 100%;height: 100%;
  position: fixed;left: 0;top:0;z-index: 700;
  background: rgba(0,0,0,.9);box-sizing: border-box;
  padding: 1.1rem 0 .5rem;
  .closed{
    position: fixed;color: $white-color;
    right: .1rem;top:.1rem;
    width: .26rem;
  }
  .mySwiper{
    /*height: calc(100% - 1rem);*/
    height: 100%;
    .swiperSlide{
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      img{
        max-width: 100%;
      }
    }
    .swiper-pagination{color:$base-grey}
    
    .swiper-lazy-preloader{
      left: 47%;
    }
  }
  
}
</style>
